module.exports = __webpack_public_path__ + "static/img/header_bar.31372cf5.png";